import { EstadoSolicitud } from "../common/enumModel";
import { ISolicitudValidarModel } from "../interfaces/solicitud/ISolicitudValidarModel";

export class SolicitudValidarModel implements ISolicitudValidarModel {
    idSolicitud: number;
    idEstado: EstadoSolicitud;
    idSupervisor: string;
    idCoordinador: string;
    comentarioPorValidacion: string;
    fechaInicio: Date;
    fechaFin: Date;    
    ordenCompra: string;
    notificarA: string;
    trabajo: string;
    motivo: string;
    subContratista: string;

    constructor(){
        this.idSolicitud = 0;
        this.idEstado = EstadoSolicitud.REVISADO;
        this.idSupervisor = '';
        this.comentarioPorValidacion = '';
        this.idCoordinador = '';
        this.fechaInicio = new Date();
        this.fechaFin = new Date(this.fechaInicio.getFullYear(), this.fechaInicio.getMonth() + 1, this.fechaInicio.getDate());
        this.ordenCompra = '';
        this.notificarA = '';
        this.trabajo = '';
        this.motivo = '';
        this.subContratista = '';
    }
}